/// <amd-module name="Agile/Common/Redux/BacklogConfiguration/BacklogConfigurationModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";

import { IBacklogConfigurationAwareState } from "./BacklogConfigurationContracts";
import { backlogConfigurationReducer } from "./BacklogConfigurationReducer";
import { loadBacklogConfiguration } from "./BacklogConfigurationSagas";

export const BacklogConfigurationModule: ISagaModule<IBacklogConfigurationAwareState> = {
    id: "backlogconfiguration",
    reducerMap: {
        backlogConfiguration: backlogConfigurationReducer
    },
    sagas: [loadBacklogConfiguration]
};
